
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/drift",
      function () {
        return require("private-next-pages/destinations/drift.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/drift"])
      });
    }
  